export const COPY_TOAST_EVENT = 'copy-toast'

export const dispatchCopyToast = (message?: string): void => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new CustomEvent(COPY_TOAST_EVENT, { detail: { message } }))
}
